<template>
    <div id="classdetailstu">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">{{name}}<span v-if="!wrongType">（{{score}}分）</span></p>
        </div>
        <template v-if="loading">
            <div class="select_wrapper"
                 v-if="wrongType">
                <select v-model="month"
                        @change="selectChange">
                    <option :value="2">2月份错题</option>
                    <option :value="3">3月份错题</option>
                    <option :value="4">4月份错题</option>
                    <option :value="5">5月份错题</option>
                </select>
            </div>
            <div class="wrap"
                 :class="{'noBottom':wrongType}"
                 v-if="question.length">
                <div class="tip"
                     v-if="!wrongType">共{{ num }}题( 答对<span>{{num - wrongNum}}</span>题, 答错<span>{{wrongNum}}</span>题 )
                </div>
                <div class="exercises"
                     v-for="(data,index) in question"
                     v-if="data.asks.length">
                    <div class="quest_title clearfix"
                         v-if="data.subject.content||data.subject.image">
                        <div>
                            <p>
                                <!-- <span class="tit_num" v-if="data.number">{{data.number}}、</span> -->
                                <span v-if="data.subject.content!=''"
                                      v-html='data.subject.content'></span>
                            </p>
                            <img :src="data.subject.image"
                                 v-if="data.subject.image!=''">
                        </div>
                    </div>
                    <!-- 小学 -->
                    <div v-if='sid == 21'>
                        <div v-for="ask,inx in data.asks">
                            <!-- 选择题 -->
                            <div class="judge-box choose"
                                 v-if="ask.display_type==1">
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <choice :question='ask'
                                        :myColor='true'
                                        :number='ask.title'
                                        :checked="true"
                                        :askLength='data.asks.length'></choice>
                            </div>
                            <!-- 填空 -->
                            <div class="judge-box"
                                 v-if='ask.display_type == 2'>
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <blanks :question='ask'
                                        :myColor='true'
                                        :number='ask.title'
                                        :checked="true"
                                        :askLength='data.asks.length'></blanks>
                            </div>
                            <!-- 主观题 -->
                            <div class="judge-box"
                                 v-if='ask.display_type == 3'>
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <subjective :ask='data.asks'
                                            :myColor='true'
                                            :index='inx'
                                            :checked="true"
                                            :question='ask'
                                            :askLength='data.asks.length'></subjective>
                            </div>
                            <!-- 连线题 -->
                            <div class="judge-box line"
                                 v-if="ask.display_type==4">
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <lines :wrongType="wrongType"
                                       :ask='ask'
                                       :sheet="ask.user_answer"
                                       :result="ask.user_result"
                                       :onlyshow='true'
                                       :myColor='true'
                                       :askLength='data.asks.length'></lines>
                            </div>

                            <div class="answer-wrap"
                                 v-if="ask.display_type==4||ask.display_type==2||(ask.display_type==1&&ask.options.length>1)">
                                <div class="user"
                                     :class="[ask.display_type == '4'?'block':'']">
                                    <div class="user-he">正确答案:</div>
                                    <div class="user-answer line"
                                         v-if="ask.display_type==4">
                                        <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.user_result" :onlyshow='true' :tag='1'></line> -->
                                        <lines :ask='ask'
                                               :sheet="ask.right_answer"
                                               :onlyshow='true'
                                               :askLength='data.asks.length'
                                               :number='data.number'
                                               :checked='true'
                                               :onlyanswer='true'
                                               :tag='1'></lines>
                                    </div>
                                    <div class="user-answer"
                                         v-else-if="ask.display_type==2">
                                        <template v-for="(a,ai) in ask.right_answer">
                                            <span v-html="a"
                                                  v-if="!ai"></span>
                                            <span v-html="'，'+a"
                                                  v-else></span>
                                        </template>
                                    </div>
                                    <!-- 正确答案 gsd -->
                                    <div class="user-answer"
                                         v-else>{{ask.right_option.option}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 初中 -->
                    <div v-else>
                        <div v-for="ask,inx in data.asks">
                            <!-- 选择题 -->
                            <div class="judge-box choose"
                                 v-if="data.display==1">
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <choice :question='ask'
                                        :myColor='true'
                                        :number='ask.title'
                                        :checked="true"
                                        :askLength='data.asks.length'
                                        :mystatus='1'></choice>
                            </div>
                            <!-- 填空 -->
                            <div class="judge-box"
                                 v-if='data.display == 2'>
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <blanks :question='ask'
                                        :myColor='true'
                                        :askLength='data.asks.length'></blanks>
                            </div>
                            <!-- 主观题 -->
                            <div class="judge-box"
                                 v-if='data.display == 3'>
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <subjective :ask='data.asks'
                                            :myColor='true'
                                            :checked="true"
                                            :index='inx'
                                            :question='ask'
                                            :askLength='data.asks.length'></subjective>
                            </div>
                            <!-- 连线题 -->
                            <div class="judge-box line"
                                 v-if="data.display == 4">
                                <div v-if="!wrongType"
                                     class="judgeicon"
                                     :myColor='true'
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <lines :ask='ask'
                                       :sheet="ask.user_answer"
                                       :onlyshow='true'
                                       :myColor='true'
                                       :result='ask.user_result'
                                       :askLength='data.asks.length'></lines>
                            </div>
                            <div class="answer-wrap">
                                <div class="user"
                                     :class="[ask.display == '4'?'block':'']">
                                    <div class="user-he">正确答案:</div>
                                    <div class="user-answer line"
                                         v-if="ask.display==4">
                                        <lines :ask='ask'
                                               :sheet="ask.right_answer"
                                               :onlyshow='true'
                                               :tag="1"></lines>
                                    </div>
                                    <div class="user-answer"
                                         v-else-if="ask.display==2">
                                        <span v-for="i in ask.right_answer">{{i}}</span>
                                    </div>
                                    <div class="user-answer"
                                         v-else>{{ask.right_option.option}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="more">
                    <more-Loading v-show='moreLoading'></more-Loading>
                </div>
            </div>
            <div class="nowork"
                 v-else>
                <div v-cloak
                     v-if="!wrongType">
                    没有作业数据
                </div>
                <div v-cloak>
                    本月错题已全部订正完
                </div>
            </div>
            <div class="bottom_btn"
                 v-if="!wrongType&&!is_active">
                <div @click="reward">奖励和评语</div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue'
import loadingS from 'SRC/components/base/tealoading.vue';
import options from 'VIEWS/math/inspect/option.vue'
import choice from 'VIEWS/math/module/choice.vue'  //选择题
import blanks from 'VIEWS/math/module/blanks.vue'  //填空题
import lines from 'VIEWS/math/module/line.vue';     //连线题
import subjective from 'VIEWS/math/module/subjective.vue';//主观题
import moreLoading from 'SRC/components/moreLoading.vue';//加载中
export default {
    data () {
        return {
            question: [],
            qids: "",
            sid: this.$route.params.sid,
            taskId: this.$route.params.taskid,
            user_id: this.$route.params.user_id,
            name: this.$route.params.username,
            classId: this.$route.params.classid,
            score: this.$route.query.score,
            is_active: Number(this.$route.query.is_active) || 0,
            loading: false,
            wrong: null,
            wrongType: Number(this.$route.query.wrongType) || 0,//从错题大扫除进来的
            page: 1,
            loadOver: false,//上拉加载加锁
            moreLoading: false,
            month: 2
        }
    },
    computed: {
        /*wrongNum(){
                   let n=0
          this.question.forEach(d => {
            if (d.user_result === 0) {
              n++
            }
          });
          return n;
        }*/
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
        toComment () {
            this.$router.push('/sx/task/classdetail/commentstu/' + this.name + '/' + this.user_id)
        },
        toRemind () {
            this.$router.push('/sx/task/classdetail/remindstu/' + this.name + '/' + this.user_id)
        },
        wrongnum (data) {
            let n = 0;
            data.forEach(d => {
                d.asks.forEach(a => {
                    if (a.user_result === 0) {
                        n++
                    }
                });
            });
            return n;
        },
        reward () {
            this.$router.push("/tea/perreward/" + this.sid + "/" + this.taskId + "/" + this.user_id + "?score=" + this.score + "&name=" + this.name);
        },
        loadMore () {
            if (!this.moreLoading && this.loading) {
                let that = this;
                this.loadMoreTimer && clearTimeout(this.loadMoreTimer);
                this.loadMoreTimer = setTimeout(function () {
                    let docHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
                    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                    let winHeight = window.screen.availHeight;
                    if (winHeight + scrollTop >= docHeight - 20) {
                        if (!that.loadOver) {
                            that.moreLoading = true;
                            that.getList(true);
                        }
                    }
                }, 500)
            }
        },
        getList (tipFlag) {
            let wrongData = {
                stu_id: this.user_id,
                month: this.month,
                p: this.page
            }
            this.$http.post(API_URL_HD_API + '/wrong_question_clear/wrong_questions/', wrongData).then((res) => {
                if (res.data.response === 'ok') {
                    if (this.page == 1) {
                        this.question = res.data.data;
                    } else {
                        this.question = this.question.concat(res.data.data);
                    }
                    this.page++;
                    this.moreLoading = false;
                    if (res.data.data.length < 10 && tipFlag) {
                        this.loadOver = true;
                        layer.tips('已加载全部内容');
                    }
                    if (!this.loading) {
                        this.loading = true;
                    }
                    this.$nextTick(function () {
                        MathJax.Hub.Typeset(document.body);
                    })
                } else {
                    layer.tips(res.data.message);
                }
            })
        },
        selectChange () {
            this.page = 1;
            this.loadOver = false;
            this.getList();
        }
    },
    async created () {
        if (this.wrongType) {
            await this.getList();
            window.addEventListener('scroll', this.loadMore, false);
        } else {
            await this.$http.post(API_URL_TASK_API + '/maths/check/task/stu_detail', {
                "message_id": this.taskId,
                "user_id": this.user_id,
                "sid": this.sid,
            }).then(res => {
                if (res.data.response == 'ok') {
                    this.loading = true;
                    this.question = res.data.data;
                    this.wrongNum = this.wrongnum(this.question);
                    let num = 0
                    this.question.forEach(d => {
                        num = num + d.asks.length
                    });
                    this.num = num;
                    this.$nextTick(function () {
                        MathJax.Hub.Typeset(document.body);
                    })
                }
            })
        }
    },
    destroyed () {
        clearTimeout(this.loadMoreTimer);
        window.removeEventListener('scroll', this.loadMore, false);
    },
    components: {
        loadingS,
        headers,
        subjective,
        choice,
        blanks,
        lines,
        moreLoading
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

[v-cloak] {
    display: none;
}

#classdetailstu {
    min-height: 100vh;
}

.wrap {
    padding-bottom: 96px / $ppr;
    &.noBottom {
        padding-bottom: 0;
    }
}


.tip {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 30px / $ppr;
    background-color: $c-fbg;
    padding: 0 $w;
    margin-bottom: $w;
    span {
        color: #ff6600;
    }
}
.select_wrapper {
    padding: 12px / $ppr 24px / $ppr;
    background-color: #fff;
    margin-bottom: 24px / $ppr;
    select {
        width: 240px / $ppr;
        height: 70px / $ppr;
        border-radius: 8px / $ppr;
        border-color: #dcdcdc;
        padding-left: 32px / $ppr;
        font-size: 30px / $ppr;
    }
}
.bottom_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 96px / $ppr;
    width: 100%;
    z-index: 8;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}

.answer-wrap {
    // padding: 30px/$ppr $w;
    background-color: #fff;
    margin-bottom: 24px / $ppr;
    min-height: 96px / $ppr;
    box-sizing: border-box;
    .user {
        color: #999;
        font-size: 30px / $ppr;
        @include displayFlex();
        align-items: center;
        // margin-right: 36px/$ppr;
        .user-he {
            padding: 30px / $ppr $w;
            margin-right: $w;
            width: 170px / $ppr;
        }
        .user-answer {
            word-break: break-all;
            word-wrap: break-word;
            @include flex();
        }
    }
}

.quest_title {
    padding: 24px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
    @include displayFlex();
    .tit_num {
        width: 48px / $ppr;
    }
    div {
        @include flex();
    }
}
.quest_title > span {
    float: left;
}
.quest_con {
    position: relative;
}

.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 304px / $ppr;
}

.judge-box {
    position: relative;
}

.judgeicon {
    position: absolute;
    right: 24px / $ppr;
    top: 0.6rem;
    z-index: 2;
    width: 40px / $ppr;
    height: 36px / $ppr;
    //background-color: #21BF63;
}

.dui {
    background-image: url(img/icon_dui.png);
    background-size: cover;
}

.cuo {
    background-image: url(img/icon_cuo.png);
    background-size: cover;
}

.exercises {
    font-family: Monospace;
    background-color: #fff;
    position: relative;
}

.block {
    display: block !important;
}

.judge-box /deep/ .title_t > img {
    left: 0;
}
.exercises /deep/ .choose {
    margin-top: 0 !important;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }
}
</style>
